import { CollectionResponse } from './data/common'
import { UserBasicResourceDto } from './data/UserBasicResource.dto'
import { Api } from '@/munio/api/base'
import { Request, URLParams } from '@/munio/http'

export default class Users extends Api {
  index(options?: URLParams) {
    return this.$get<CollectionResponse<UserBasicResourceDto>>(this.$route('api.web.admin.users'), this.$query(options))
  }

  remove(users: number[]) {
    return this.$delete<Request<null>>(this.$route('api.web.admin.users.remove'), { users })
  }

  assignRoles(users: number[], roles: number[]) {
    return this.$post<Request<null>>(this.$route('api.web.admin.users.assign.roles'), { users, roles })
  }

  assignCourses(users: number[], courses: number[]) {
    return this.$post<Request<null>>(this.$route('api.web.admin.users.assign.courses'), { users, courses })
  }
}
